import { useEffect, useState } from "react";

import validations from "@/admin/utils/validations";
/**
 * Validate the User Email availability.
 *
 * @param {(string)} username email of the user.
 * @returns {{data: Object, error: string}} Info about the query state.
 */
const useValidateUserEmail = (username) => {
  const [isAvailable, setIsAvailable] = useState(false);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        setIsLoading(true);
        setIsAvailable(false);
        setError(null);

        const { isValid, message } = await validations.validateEmail(
          username,
          true,
        );

        if (isValid) {
          setIsAvailable(true);
          setError(null);
          setIsLoading(false);
        } else {
          setError(message);
          setIsAvailable(false);
          setIsLoading(false);
        }
      } catch (error) {
        setIsAvailable(true);
        setError(null);
        setIsLoading(false);
        console.error(error);
      }
    })();
  }, [username]);

  return { isAvailable, error, isLoading };
};

export default useValidateUserEmail;
